<div class="payment-partial-container">
  <div>
    <h1>Оплата</h1>

    <div class="container">
      <div class="container__item margin-bottom--40">
        <el-form-item prop="payment.whoPaysForCargoTransportation">
          <template #label> Плательщик грузоперевозки «склад-склад» </template>
          <el-radio-group
            class="font-size_el-radio-button__inner el-radio-button__who-pays"
            v-model="dataForm.payment.whoPaysForCargoTransportation"
            @change="handlerChangeWhoPays('whoPaysForCargoTransportation')"
          >
            <el-radio-button v-for="option in optionsWhoPays" :key="option.value" :label="option.label" :disabled="checkingPresenceThirdPerson(option.label)" />
          </el-radio-group>
        </el-form-item>
        <el-form-item prop="payment.typeOfPaymentForCargoTransportation">
          <el-radio-group
            class="font-size_el-radio-button__inner el-radio-button__type-payment"
            v-model="dataForm.payment.typeOfPaymentForCargoTransportation"
            @change="handlerChangeTypeOfPayment('typeOfPaymentForCargoTransportation')"
          >
            <el-radio-button v-for="option in optionsTypeOfPayment" :key="option.value" :label="option.label" />
          </el-radio-group>
        </el-form-item>
      </div>

      <div v-if="dataForm.applicationCargoPickup.deliveryToTheAddress" class="container__item margin-bottom--40-p">
        <el-form-item prop="payment.whoPaysForCargoDelivery">
          <template #label> Плательщик доставки </template>
          <el-radio-group
            class="font-size_el-radio-button__inner el-radio-button__who-pays"
            v-model="dataForm.payment.whoPaysForCargoDelivery"
            @change="handlerChangeWhoPays('whoPaysForCargoDelivery')"
          >
            <el-radio-button v-for="option in optionsWhoPays" :key="option.value" :label="option.label" :disabled="checkingPresenceThirdPerson(option.label)" />
          </el-radio-group>
        </el-form-item>
        <el-form-item prop="payment.typeOfPaymentForCargoDelivery">
          <el-radio-group
            class="font-size_el-radio-button__inner el-radio-button__type-payment"
            v-model="dataForm.payment.typeOfPaymentForCargoDelivery"
            @change="handlerChangeTypeOfPayment('typeOfPaymentForCargoDelivery')"
          >
            <el-radio-button v-for="option in optionsTypeOfPayment" :key="option.value" :label="option.label" />
          </el-radio-group>
        </el-form-item>
      </div>

      <div v-if="dataForm.cargoInformation.additionalPackaging" class="container__item margin-bottom--40-p">
        <el-form-item prop="payment.whoPaysForCargoExtraPacking">
          <template #label> Плательщик доп упаковки </template>
          <el-radio-group
            class="font-size_el-radio-button__inner el-radio-button__who-pays"
            v-model="dataForm.payment.whoPaysForCargoExtraPacking"
            @change="handlerChangeWhoPays('whoPaysForCargoExtraPacking')"
          >
            <el-radio-button v-for="option in optionsWhoPays" :key="option.value" :label="option.label" :disabled="checkingPresenceThirdPerson(option.label)" />
          </el-radio-group>
        </el-form-item>
        <el-form-item prop="payment.typeOfPaymentForCargoExtraPacking">
          <el-radio-group
            class="font-size_el-radio-button__inner el-radio-button__type-payment"
            v-model="dataForm.payment.typeOfPaymentForCargoExtraPacking"
            @change="handlerChangeTypeOfPayment('typeOfPaymentForCargoExtraPacking')"
          >
            <el-radio-button v-for="option in optionsTypeOfPayment" :key="option.value" :label="option.label" />
          </el-radio-group>
        </el-form-item>
      </div>
    </div>
  </div>

  <div>
    <el-form-item class="margin-bottom--0" prop="payment.isAgreeDataProcessing">
      <el-checkbox class="white-space--normal" label="Я даю согласие на обработку моих персональных данных" v-model="dataForm.payment.isAgree" />
    </el-form-item>

    <el-form-item>
      <!-- <el-checkbox
        class="white-space--normal"
        prop="payment.isAgreeEmailMailing"
        label="Я хочу подписаться на Email рассылку"
        v-model="dataForm.payment.isAgreeEmailMailing "
      /> -->
    </el-form-item>

    <div class="bord_button">
      <el-form-item>
        <el-button class="button__send" type="primary" @click="$emit('click-button-back')"> Назад </el-button>
      </el-form-item>
      <el-form-item>
        <el-button class="button__send white-space--normal" type="primary" @click="$emit('submit-form-sender', ruleFormRef)" :disabled="!dataForm.payment.isAgree"> Отправить заявку </el-button>
      </el-form-item>
    </div>
  </div>
</div>
